function validDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value || ''))) return false;
    const parsed = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}

function focusTarget(query) {
    const source = query || {};
    const employeeId = Number(source.employee_id);
    return source.plan_intent === 'focus' && Number.isSafeInteger(employeeId)
        && employeeId > 0 && validDate(source.date)
        ? {employeeId, date: source.date} : null;
}

// Both entry points pass only assignment dates, never rates or personnel events.
function employeePlanRoute(employeeId, date, assignmentDates) {
    const nextDate = (assignmentDates || []).filter(value => validDate(value) && value > date).sort()[0];
    return {
        name: 'employees-workforce-plan',
        query: {employee_id: Number(employeeId), date: nextDate || date, plan_intent: 'focus'}
    };
}

function focusScrollPosition({row, column, rowHeight, contentOffset, viewport, pinnedWidth, weekWidth}) {
    return {
        top: Math.max(0, contentOffset + row * rowHeight - viewport.clientHeight / 2 + rowHeight / 2),
        left: Math.max(0, column * weekWidth - (viewport.clientWidth - pinnedWidth) / 2 + weekWidth / 2)
    };
}

module.exports = {validDate, focusTarget, employeePlanRoute, focusScrollPosition};
